import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format date to German format DD.MM.YYYY HH:mm
export function formatDate(dateString) {
  if (!dateString || dateString === '-') return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Format date to German format DD.MM.YYYY
export function formatDateShort(dateString) {
  if (!dateString || dateString === '-') return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

// Get status label in German
export function getStatusLabel(status) {
  const labels = {
    active: 'Aktiv',
    maintenance_due: 'Wartung fällig',
    end_of_life: 'End of Life',
    blocked: 'Gesperrt',
    in_maintenance: 'In Wartung',
  };
  return labels[status] || status;
}

// Get status color class
export function getStatusClass(status) {
  const classes = {
    active: 'status-active',
    maintenance_due: 'status-maintenance',
    end_of_life: 'status-eol',
    blocked: 'status-blocked',
    in_maintenance: 'status-maintenance',
  };
  return classes[status] || 'status-blocked';
}

// Calculate cycle percentage
export function getCyclePercentage(remaining, max) {
  if (!max || max === 0) return 0;
  return Math.round((remaining / max) * 100);
}

// Download file helper
export function downloadFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
